/* eslint-disable */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function TaxRevenueTypesContent({
  handleAddModal,
  handleEdit,
  taxRevenueTypeId,
  getSingleTaxRevenueTypes,
  taxRevenueTypesInfo,
}) {
  const permissions = getJson('permissions');

  useEffect(() => {
    if (_.isEmpty(taxRevenueTypeId)) return;
    getSingleTaxRevenueTypes(taxRevenueTypeId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(taxRevenueTypeId)) return;
    getSingleTaxRevenueTypes(taxRevenueTypeId);
  }, [taxRevenueTypeId]);

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        {/* <div className="row pt-4 pb-2 bg-white">
          <div className="col-12 d-flex">
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
            >
              Add Tax Revenue Types &nbsp;&nbsp;
              <i className="fas fa-plus" />
            </button>
          </div>
        </div> */}
        {!_.isEmpty(taxRevenueTypesInfo) ? (
          <React.Fragment>
            <div className="row bg-white pb-3">
              <div className="col-8">
                <h2 className="">
                  {_.get(taxRevenueTypesInfo, 'attributes.name')}
                </h2>
                <span className="full-input">
                  {_.get(taxRevenueTypesInfo, 'attributes.description')}
                </span>
              </div>
              <div className="col-4 d-flex">
                <div className="py-3 ml-auto">
                  {Acl(permissions, ['UPDATE TAX REVENUE TYPES']) && (
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(taxRevenueTypesInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                  )}
                </div>
              </div>
              <div className="col-12">
                <div className="form-wrapper mb-3 p-3">
                  <table className="transaction-table table table-borderless table-sm ">
                    <tbody>
                      <tr>
                        <td className="text-dark" width="250">
                          Code
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(taxRevenueTypesInfo, 'attributes.code')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Name
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(taxRevenueTypesInfo, 'attributes.name')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Description
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              taxRevenueTypesInfo,
                              'attributes.description'
                            )}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Type
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(taxRevenueTypesInfo, 'attributes.type')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          With Quarterly Calculation
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              taxRevenueTypesInfo,
                              'attributes.with_quarterly_calculation'
                            )
                              ? 'YES'
                              : 'NO'}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Cumulative Amount in View OR
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              taxRevenueTypesInfo,
                              'attributes.cumulative_amount_or'
                            )
                              ? 'YES'
                              : 'NO'}
                          </b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

TaxRevenueTypesContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,

  getSingleTaxRevenueTypes: PropTypes.instanceOf(Function).isRequired,
  taxRevenueTypesInfo: PropTypes.instanceOf(Object).isRequired,
  taxRevenueTypeId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  taxRevenueTypesInfo:
    _.get(api, `${c.GET_SINGLE_TAX_REVENUE_TYPES}.item`) || {},
  taxRevenueTypeId: _.get(match, 'params.taxRevenueTypeId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TaxRevenueTypesContent);
